import { Container, Modal } from '@mui/material';
import React from 'react';
import { FinsightEntityField } from 'shared';

import { FieldEditor } from '..';

interface PropertyEditorModalProps {
  open: boolean;
  onClose: () => void;
  currentEditingPropertyIndex: number | null;
  field: FinsightEntityField['schema'];
  onPropertyUpdate: (updatedProperty: FinsightEntityField['schema']) => void;
}

export function PropertyEditorModal({
  open,
  onClose,
  currentEditingPropertyIndex,
  field,
  onPropertyUpdate,
}: PropertyEditorModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          bgcolor: 'background.paper',
          borderRadius: 2,
          p: 3,
          maxHeight: '90vh',
          overflow: 'auto',
        }}
      >
        {currentEditingPropertyIndex !== null &&
          Array.isArray(field.properties) && (
            <FieldEditor
              fieldName={
                field.properties[currentEditingPropertyIndex].name || ''
              }
              field={field.properties[currentEditingPropertyIndex]}
              setField={onPropertyUpdate}
            />
          )}
      </Container>
    </Modal>
  );
}
